import splitKeyword from '../../../../../../utils/split-search-query/index.js';

const contains = (haystack, needle) => haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;

const cellContains = (row, key, word) => {
  const cellContent = row.formatted[key];
  return contains(cellContent, word);
};

const isKeywordInRow = (row, word, searchKeys) => {
  return searchKeys.some(key => cellContains(row, key, word));
};

const search = (content, [keyword, columnDefinitions, searchKeys]) => {
  if (!columnDefinitions.length || !keyword) { return content; }
  const keys = searchKeys || columnDefinitions.map(column => column.contentKey);

  const keywords = splitKeyword(keyword);

  return content.filter(row => {
    return keywords.every(keyword => {
      return isKeywordInRow(row, keyword, keys);
    });
  });
};

export default search;
